import type { Timestamp } from "interfaces/FirestoreTimestampIF"

export const deserializeTimestamp = (timestamp: Timestamp): string => {
  const createdAt = new Date(timestamp._seconds * 1000)
  const createdAtYear = createdAt.getFullYear()
  const createdAtMonth = createdAt.getMonth() + 1
  const createdAtDay = createdAt.getDate()

  return createdAtYear + "年" + createdAtMonth + "月" + createdAtDay + "日"
}

export const deserializeTimestamp2 = (timestamp: Timestamp): string => {
  const createdAt = (timestamp as any).toDate()
  const createdAtYear = createdAt.getFullYear()
  const createdAtMonth = createdAt.getMonth() + 1
  const createdAtDay = createdAt.getDate()

  return createdAtYear + "年" + createdAtMonth + "月" + createdAtDay + "日"
}
